export default "__VITE_ASSET__f5eb5f11__"